import { client } from '../client';
import { IGMConversation } from './types/IGMConversation';

export interface ICaseConversation extends IGMConversation {
  archived_at: string | null;
  conversation_type: string;
  is_current: boolean;
}

/**
 * Lists every conversation ever linked to a case, including archived or
 * superseded threads the case no longer points at (their message history is
 * otherwise unreachable). Lives on the shared /cases router — role gating
 * happens server-side, so no staff prefix is applied.
 */
export const getCaseConversations = async (caseId: number | string): Promise<ICaseConversation[]> => {
  if (!caseId) {
    return Promise.reject(new Error('Case ID is required'));
  }
  const { data } = await client.get(`/cases/${caseId}/conversations`);
  return data.nodes;
};
